import { MenuItem, Select } from "@mui/material";

/** Mesmo contorno dos filtros do sistema (FILTER_FIELD_SX), em versão compacta p/ célula de tabela. */
const SX_SIM_NAO = {
  width: "92px",
  height: "32px",
  fontSize: "13px",
  fontWeight: 400,
  borderRadius: "8px",
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "divider" },
  "& .MuiSelect-select": { display: "flex", alignItems: "center", minHeight: "unset", py: 0, pl: "10px" },
};

/**
 * Sim/Não editável da lista de rúbricas (Incidência da Rubrica e Verbas de Afastamento):
 * seletor compacto no visual dos filtros do sistema, sem campo de busca (são só 2 opções).
 *
 * @param {{ value: boolean, disabled?: boolean, onChange: (v: boolean) => void, ariaLabel: string }} props
 */
export default function DropdownSimNao({ value, disabled, onChange, ariaLabel }) {
  return (
    <Select
      size="small"
      value={value ? "sim" : "nao"}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value === "sim")}
      // aria-labelledby (que o MUI põe por padrão) venceria o aria-label: remove para o nome valer.
      SelectDisplayProps={{ "aria-label": ariaLabel, "aria-labelledby": undefined }}
      sx={SX_SIM_NAO}
    >
      <MenuItem value="sim">Sim</MenuItem>
      <MenuItem value="nao">Não</MenuItem>
    </Select>
  );
}
